import { render, staticRenderFns } from "./VinovAcikRizaModal.vue?vue&type=template&id=fb184d02&scoped=true"
import script from "./VinovAcikRizaModal.vue?vue&type=script&lang=js"
export * from "./VinovAcikRizaModal.vue?vue&type=script&lang=js"
import style0 from "./VinovAcikRizaModal.vue?vue&type=style&index=0&id=fb184d02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb184d02",
  null
  
)

export default component.exports